// Lead Status Options
export const LEAD_STATUS_OPTIONS = [
  { label: 'New', value: 'NEW' },
  { label: 'Contacted', value: 'CONTACTED' },
  { label: 'Follow-Up', value: 'FOLLOW_UP' },
  { label: 'Clinic Visited', value: 'CLINIC_VISITED' },
  { label: 'Not Interested', value: 'NOT_INTERESTED' },
  { label: 'No Response', value: 'NO_RESPONSE' },
  { label: 'Invalid', value: 'INVALID' },
  { label: 'Lost', value: 'LOST' },
] as const;

// Engagement Mode Options
export const ENGAGEMENT_MODE_OPTIONS = [
  { label: 'Call', value: 'CALL' },
  { label: 'WhatsApp', value: 'WHATSAPP' },
  { label: 'Instagram', value: 'INSTAGRAM' },
  { label: 'Other', value: 'OTHER' },
] as const;

// Interest Options
export const INTEREST_OPTIONS = [
  { label: 'LHR', value: 'LHR' },
  { label: 'Peel', value: 'PEEL' },
  { label: 'Hydrafacial', value: 'HYDRAFACIAL' },
  { label: 'Clinical', value: 'CLINICAL' },
  { label: 'Carbon Facial', value: 'CARBON_FACIAL' },
  { label: 'Tan removal', value: 'TAN_REMOVAL' },
  { label: 'Others', value: 'OTHERS' },
] as const;

// Source Options
export const SOURCE_OPTIONS = [
  { label: 'Google', value: 'GOOGLE' },
  { label: 'Facebook', value: 'FACEBOOK' },
  { label: 'Referral', value: 'REFERRAL' },
  { label: 'Instagram', value: 'INSTAGRAM' },
  { label: 'WhatsApp', value: 'WHATSAPP' },
  { label: 'Walk-In', value: 'WALK_IN' },
  { label: 'Coupon', value: 'COUPON' },
  { label: 'Other', value: 'OTHER' },
] as const;

// Status Filter Options
export const STATUS_FILTER_OPTIONS = LEAD_STATUS_OPTIONS;

// Source Filter Options
export const SOURCE_FILTER_OPTIONS = SOURCE_OPTIONS;

// Engagement Mode Filter Options
export const ENGAGEMENT_MODE_FILTER_OPTIONS = ENGAGEMENT_MODE_OPTIONS;

// Interest Filter Options
export const INTEREST_FILTER_OPTIONS = INTEREST_OPTIONS;
